import cacheService from '../../../services/cacheService';
import submitCommand from '../../../services/submitCommand';
import { refreshSessionUser } from '../../authentication/utils/refreshSessionUser';

export const createOrgAccount = (orgId: string, name: string, ownerId: string, churchAccountId?: string) =>
  new Promise((resolve, reject) => {
    if (churchAccountId && orgId.toLowerCase() !== churchAccountId.toLowerCase()) {
      return reject('Org ID and Church Account ID must be the same if Church Account ID is present.');
    }

    const command = {
      id: orgId.toLowerCase(),
      name,
      owner: { id: ownerId },
    };

    if (churchAccountId) {
      Object.assign(command, { churchAccountId });
    }

    cacheService.removeAllInPath('/v2/user/associated-church-accounts');
    cacheService.removeAllInPath('/v2/user/organizations');
    cacheService.removeAllInPath('/v1/organizations');
    cacheService.remove('/v1/license-pairing-orgs');

    submitCommand(
      command.id,
      command,
      'CreateOrgAccount',
      'OrgAccountRoleAssigned', // the last event to fire in the org creation process
      ['OrgAccountError', 'AlreadyExists']
    )
      .then(response => refreshSessionUser().then(() => resolve(response)))
      .catch(reject);
  });
